/* eslint-disable no-console */
import axios from 'axios'

axios.interceptors.request.use(
  (config) => config,
  (error) => {
    console.info({
      type: 'request',
      name: error.name,
      code: error.code,
      message: error.message,
      apiURL: error.config.url,
      pageURL: window.location.href,
      isOnline: navigator.onLine,
    })
    return Promise.reject(error)
  },
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code !== 'ERR_CANCELED') {
      console.info({
        type: 'response',
        name: error.name,
        code: error.code,
        message: error.message,
        apiURL: error.config.url,
        pageURL: window.location.href,
        isOnline: navigator.onLine,
      })
    }

    return Promise.reject(error)
  },
)
